import Http from '@/classes/http/Http'
import { API_ROOT } from '@/api/config'

// A header, not a body field: see norse_common/recaptcha.py.
export const captchaHeaders = (captchaToken) => {
  if (!captchaToken) {
    return undefined
  }
  return { 'X-Recaptcha-Token': captchaToken }
}

export default {
  getRecaptchaConfig: function () {
    return Http.get({
      base_url: API_ROOT,
      url: `recaptcha-config`
    })
  }
}
